import { render, staticRenderFns } from "./ProductsOnLocation.vue?vue&type=template&id=bc3959a6&scoped=true&"
import script from "./ProductsOnLocation.vue?vue&type=script&lang=js&"
export * from "./ProductsOnLocation.vue?vue&type=script&lang=js&"
import style0 from "./ProductsOnLocation.vue?vue&type=style&index=0&id=bc3959a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3959a6",
  null
  
)

export default component.exports